<template>
    <div>
        <div v-for="(item, index) in getListLesonPlan" :key="index">
            <div class="detail-week">
                <!-- <router-link
                :to="{ path: `/lop-hoc/mon-${classSchoolSubjectId}/noi-dung/chi-tiet-${item.lessonPlanId}` }"> -->
                   <a href="javascript:;" @click="goToSubjectPage(index,item)">
                    <h3 class="font-sanpro-semibold primary-color font-size-16">{{item.title}}</h3>
                    <h3 class="font-family-Semibold secondary-color-txt font-size-14">{{moment(item.fromDate).format(formatDate1)}} -  {{moment(item.toDate).format(formatDate1)}} </h3>
                    <h3 class="font-family-Semibold secondary-color-txt font-size-14">{{item.numberOfLesson}} - {{item.numberOfDocument}}</h3>
                   </a>
                <!-- </router-link> -->
            </div>
            <div class="detail-space"></div>
        </div>
         <!-- <router-link
                :to="{ path: `/lop-hoc/noi-dung/chi-tiet-${item.subjectWeekId}` }"> -->
        <!-- <span>{{subjectLists}}</span> -->
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../../_store/constants";
import {LOCAL_SAVE_CHRISTMAS_CARD} from "../../_store/constants"
import moment from "moment";
export default {
    name:"ContentSubject",
    data(){
        return{
            formatDate1: "DD/MM/YYYY",
            classSchoolSubjectId : this.$route.params.id,
        }
    },
      computed: {
        ...mapGetters({
             getListLesonPlan: STORE_KEY + "/getListLesonPlan",
        })
    },
    mounted() {
        // console.log("ok");
        // this.actionGetListSubjectInWeek();
    },
    methods: {
       ...mapActions(`${STORE_KEY}`, ["actionGetListSubjectInWeek"]),
       moment,
           goToSubjectPage(index,item) {
      localStorage.setItem(LOCAL_SAVE_CHRISTMAS_CARD, index);

      this.$router.push({
        name: "ViewDetailSubjectContent",
        params: { id: this.classSchoolSubjectId, lessonPlanId: item.lessonPlanId }
      });
    }
    }
}
</script>

<style lang="scss" scoped>
 .detail-week{
        text-align: center;
        padding: 15px 15px 5px 15px;
        border-radius: 5px;
        &:hover{
            background: #f3f6fb;
        }
        &:focus{
            background: #f3f6fb;
        }
    }
    .detail-space{
        border-bottom: 1px solid #d8d8d8;
    }
</style>